// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Book(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Book" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 4C4.5 3.44772 4.94772 3 5.5 3H19.5V19H6C5.72386 19 5.5 19.2239 5.5 19.5C5.5 19.7761 5.72386 20 6 20H19.5L18.625 21H5.5C4.94772 21 4.5 20.5523 4.5 20V4ZM17 7.5H8V9H17V7.5ZM8 10.5H17V12H8V10.5ZM17 13.5H8V15H17V13.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Book.js.map